module.exports = require("@seddi/three/examples/jsm/postprocessing/ShaderPass.js");